(function() {
  
  const wrapper =  document.querySelector('product-form');
  const options = wrapper.querySelectorAll('[name^="options"]');
  const addToCartBtn = wrapper.querySelector('[data-bundle-custom-add-to-cart]');
  const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
  const bundleJson = JSON.parse(document.querySelector('[data-bundle-custom-json]').innerHTML);

  var selected = [];

  init();

  function init() {
    addToCartBtn.addEventListener('click', handleAddToCart);
    options.forEach((opt) => {
      opt.addEventListener('change', handleOptionChange);
    })
  }

  function handleOptionChange(e) {
    var targetProduct = e.target.closest('[data-bundle-item-product]');
    var targetProductGroup = e.target.closest('[data-bundle-item-product-group]');
    let product, selectedVariant;

    if (targetProduct) {
      var targetId = parseFloat(targetProduct.dataset.bundleItemProduct);
      product = bundleJson
        .map((item) => item.product)
        .find((product) => product.id === targetId);

      var targetOptions = targetProduct.querySelectorAll('[name^="options"]');
      var optionsArr = Array.from(targetOptions);
      selectedVariant = getVariantFromOptionArray(product, optionsArr);

      targetProduct.dataset.bundleItemSelectedVariant = selectedVariant.id;

      var targetMedia = targetProduct.querySelector('[data-product-media]');
      if (targetMedia) {
        renderProductMedia(targetMedia, selectedVariant.id);
      }
      updateIncludesVariant(targetId, selectedVariant);

    } else if (targetProductGroup) {
      targetProductGroup.dataset.bundleItemSelectedVariant = e.target.value;
      
      var targetMedia = targetProductGroup.querySelector('[data-product-media]');
      if (targetMedia) {
        renderProductMedia(targetMedia, e.target.value);
      }
      updateIncludesProduct(targetProductGroup.dataset.bundleItemGroupIndex, e.target.value);
    }
  }

  function handleAddToCart() {
    const qtySelect = wrapper.querySelector('[data-quantity-input]');
    const setEl = wrapper.querySelector('[data-bundle-custom-parent]');
    const setTitle = setEl.getAttribute('data-bundle-custom-parent-title');
    const setHandle = setEl.getAttribute('data-bundle-custom-parent-handle');
    const setDiscount = setEl.getAttribute('data-bundle-custom-parent-discount');
    const setCommissionable = setEl.getAttribute('data-bundle-custom-parent-commissionable');
    const setIsKit = setEl.getAttribute('data-bundle-custom-parent-is-kit');
    const sellingPlan = document.querySelector('select[name="rc_selling_plan"]');

    var multiplier = qtySelect ? parseFloat(qtySelect.value) : 1;
    var sellingPlanIndex = sellingPlan ? sellingPlan.selectedIndex : null;

    selected = bundleJson.map(function(item) {
      var item_product = null;
      var item_selected_variant_id = null;
      var item_selling_plan = null;

      if (item.type === 'group') {
        const targetProductGroupEl = wrapper.querySelector(`[data-bundle-item-group-index="${ item.group_index }"]`);
        if (targetProductGroupEl) {
          item_selected_variant_id = parseFloat(targetProductGroupEl.dataset.bundleItemSelectedVariant);
          item_product = item.all_options.find((option) => option.product.variants.find((variant) => variant.id === item_selected_variant_id)).product;
        }
      } else {
        item_product = item.product;
        if (item_product.variants.length > 1) {
          const targetProductEl = wrapper.querySelector(`[data-bundle-item-product="${ item_product.id }"]`);
          if (targetProductEl) {
            item_selected_variant_id = parseFloat(targetProductEl.dataset.bundleItemSelectedVariant);
          }
        } else { // non-personalizable items
          item_selected_variant_id = item_product.variants[0].id;
        }
      }
    
      // get selected selling plan
      if (sellingPlanIndex !== null && 
          item_product.selling_plan_groups.length && 
          item_product.selling_plan_groups[0].selling_plans &&
          item_product.selling_plan_groups[0].selling_plans[sellingPlanIndex]) {
        item_selling_plan = item_product.selling_plan_groups[0].selling_plans[sellingPlanIndex].id;
      }

      return {
        id: item_selected_variant_id,
        quantity: multiplier,
        selling_plan: item_selling_plan,
        properties: {
          _set: setTitle,
          _set_handle: setHandle,
          _set_discount: setDiscount,
          _set_type: "Custom",
          _set_commissionable: setCommissionable,
          _set_is_kit: setIsKit !== null
        }
      }
    });

    addToCartAction(selected, addToCartBtn);
  }

  function updateIncludesVariant(id, variant) {
    const targetIncludesProduct = document.querySelector(`[data-includes-bundle-item-product="${id}"]`);
    const targetIncludesVariantTitle = targetIncludesProduct.querySelector('[data-includes-bundle-item-variant-title]');
    const targetIncludesMedia = targetIncludesProduct.querySelector('[data-includes-bundle-item-media]');

    targetIncludesVariantTitle.textContent = variant.title;
    if (variant.featured_image && targetIncludesMedia) {
      renderProductMedia(targetIncludesMedia, variant.id);
    }
  }

  function updateIncludesProduct(index, variant_id) {
    const targetIncludesProduct = document.querySelector(`[data-includes-bundle-item-group-index="${index}"]`);
    const targetIncludesTitle = targetIncludesProduct.querySelector('[data-includes-bundle-item-group-title]');
    const targetIncludesContent = targetIncludesProduct.querySelector('[data-includes-bundle-item-group-content]');
    const targetIncludesMedia = targetIncludesProduct.querySelector('[data-includes-bundle-item-group-media]');

    if (targetIncludesTitle) {
      renderProductTitle(targetIncludesTitle, variant_id);
    }
    if (targetIncludesContent) {
      renderProductContent(targetIncludesContent, variant_id);
    }
    if (targetIncludesMedia) {
      renderProductMedia(targetIncludesMedia, variant_id);
    }
  }

  /*------- Helpers -------*/

  function serializeInputValues(inputs, transform) {
    return inputs.reduce(function (options, input) {
      if (
        input.checked || // If input is a checked (means type radio or checkbox)
        (input.type !== 'radio' && input.type !== 'checkbox' && input.value !== '') // Or if its any other type of input
      ) {
        options.push(transform({name: input.name, value: input.value}));
      }

      return options;
    }, []);
  }

  function getSelectedOptions(options) {
    return serializeInputValues(options, function (item) {
      var regex = /(?:^(options\[))(.*?)(?:\])/;
      item.name = regex.exec(item.name)[2];
      return item;
    });
  }

  function findVariantsInOptionArray(product, options) {
    const optionsSelected = getSelectedOptions(options);

    var optionsSelectedArr = [];
    optionsSelected.forEach(function (option) {
      for (var i = 0; i < product.options.length; i++) {
        var name = product.options[i].name || product.options[i];
        if (name.toLowerCase() === option.name.toLowerCase()) {
          optionsSelectedArr[i] = option.value;
          break;
        }
      }
    });

    var result = product.variants.filter(function (variant) {
      return optionsSelectedArr.every(function (option, index) {
        return variant.options[index] === option;
      });
    });

    return result;
  }

  function getVariantFromOptionArray(product, options) {
    const optionsSelected = getSelectedOptions(options);
    var result = findVariantsInOptionArray(product, options);
    
    if (optionsSelected.length === product.options.length) {
      return result[0] || null;
    } else return null;
  }

  function renderProductMedia(target_media, id) {
    window
      .fetch(`${window.theme.routes.root_url}variants/${id}/?section_id=api-product-media`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response;
        target_media.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  function renderProductTitle(target_title, id) {
    window
      .fetch(`${window.theme.routes.root_url}variants/${id}/?section_id=api-product-title`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response;
        target_title.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  function renderProductContent(target_content, id) {
    window
      .fetch(`${window.theme.routes.root_url}variants/${id}/?section_id=api-product-content`)
      .then((response) => {
        return response.text();
      })
      .then((response) => {
        // handle success
        const fresh = document.createElement('div');
        fresh.innerHTML = response;
        target_content.innerHTML = fresh.querySelector('[data-api-content]').innerHTML;
      })
      .catch(function (error) {
        console.warn(error);
      });
  }

  function addToCartAction(selected, btn) {
    const formData = {
      'items': selected
    }

    if (selected.length) {
      btn.disabled = true;
      btn.classList.add('loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
      .then((res) => {
        if (!res.ok) throw new Error("Unable to add to cart");
        return res.json();
      })
      .then((data) => {
        reloadCart();
        btn.classList.remove('loading');
        btn.classList.add('has-success');

        setTimeout(() => {
          btn.classList.remove('has-success');
          btn.disabled = false;
          openDrawer();
        }, 1500);
      })
      .catch((err) => {
        btn.classList.remove('loading');
        console.error(err);
      })
    }
  }

  function reloadCart() {
    document.dispatchEvent(
      new CustomEvent('theme:cart:init', {
        bubbles: true
      })
    );
    document.dispatchEvent(
      new CustomEvent("theme:cart:reload", {
        bubbles: true,
      })
    );
  }

  function openDrawer() {
    cartDrawer.dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: true,
      })
    );
  }

})();